<template>
  <div>
    <CardedSectionHeader
      icon="mdi-television"
      label="Promotion Preview"
      id="admin_promotion_featuring_delete_preview"
    ></CardedSectionHeader>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="featured_promotion.promotion"
          :is_owner_view="is_owner"
          :is_in_admin_view="true"
        ></PromotionHeader>
        <div class="d-flex justify-space-between align-center pt-4 pb-4 grey lighten-5 pr-2 pl-2">
            <div>
                Platform: <b>{{featured_promotion.platform}}</b>
            </div>
            <div>Page: <b>{{featured_promotion.page}}</b></div>
            <div>Section: <b>{{featured_promotion.section}}</b></div>
        </div>
      </PlainDisplay>
    </CardedDisplay>
    <DeleteConcentForm
      ref_prop="featured_promotion_admin_delete_form_ref"
      id="featured_promotion_admin_delete_form"
      message="<b>Delete was succesfull</b> <br/> Promotion Featuring has been removed successfully"
      :is_loading="is_loading"
      :seed="{ featured_promotion: [$route.params.id] }"
      @on-delete-success="on_success_delete"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>

<script>
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import DeleteConcentForm from "./../../../components/DeleteConcentForm";
import AdminPromotionsFeaturedAdd from "./AdminPromotionsFeaturedAdd"
export default {
  name: "AdminPromotionsFeaturedDelete",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    AdminPromotionsFeaturedAdd,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    }
  },
  data: function () {
    return {
      featured_promotion_id: 0,
      featured_promotion: Utils.get_default_fetaured_promotion(),
      is_owner: false,
      _user: null
    }
  },
  methods: {
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_featured_promotion(
        {
          id: this.featured_promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.promotion.expiry = "";
          if (php_time_now < parseFloat(res.promotion.starts_on_timestamp)) {
            res.promotion.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.promotion.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.promotion.ends_on_timestamp)
          ) {
            res.promotion.expiry = "live";
          } else if (php_time_now > parseFloat(res.promotion.ends_on_timestamp)) {
            res.promotion.expiry = "expired";
          }

          this.featured_promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.featured_promotion.promotion.business &&
            parseInt(this._user.id) == parseInt(this.featured_promotion.promotion.user_id)
          ) {
            this.is_owner = true;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading featured promotion for delete  view",
            errors
          );
        }
      );
    },
    on_success_delete(){
        this.$router.push("/admin/promotions/featured");
    }
  },
  mounted() {
    this.cmp_user = ServerClient.Login.get_logged_in_user();
    this.featured_promotion_id = parseInt(this.$route.params.id);
    //nyd
    //if the _user is not or they are not admins there  then just take this dude
    //to the loggin screen

    this.$emit("set-page-attributes", {
      title: "Delete Promotion's Featuring",
      crumps: [
        {
          text: "admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "Feature",
          disabled: false,
          href: "/admin/promotions/featured",
        },
        {
          text: "Delete",
          disabled: true,
          href: "/admin/promotions/featured/delete/" + this.featured_promotion_id,
        },
      ],
      navbar_cols: 3,
    });

    this.load_promotion();
  },
};
</script>